import React from 'react';
import { Link } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { FaEnvelope, FaQuestionCircle, FaComments, FaBook } from "react-icons/fa";

class SupportPage extends React.Component {
  render() {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)',
        paddingTop: '70px',
        paddingBottom: '70px'
      }}>
        {/* Top Navbar */}
        <Navbar expand="sm" fixed="top" style={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
        }}>
          <Link to="/" style={{ marginLeft: '1rem' }}>
            <img src="/images/p10.jpg" alt="Logo" style={{ height: '40px',borderRadius: '8px' }} />
          </Link>
          <Nav className="ml-auto" style={{ marginRight: '1rem' }}>
            <Link to="/about" style={{ 
              color: '#667eea', 
              textDecoration: 'none',
              fontWeight: '600',
              marginLeft: '1.5rem'
            }}>
              About
            </Link>
          </Nav>
        </Navbar>

        {/* Main Content */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          minHeight: 'calc(100vh - 140px)',
          padding: '40px 20px'
        }}>
          <div style={{ 
            maxWidth: '900px',
            width: '100%'
          }}>
            {/* Hero Section */}
            <div style={{ 
              textAlign: 'center',
              marginBottom: '3rem',
              color: 'white'
            }}>
              <h1 style={{ 
                fontSize: '3rem',
                fontWeight: '700',
                marginBottom: '1rem',
                textShadow: '0 2px 10px rgba(0,0,0,0.2)'
              }}>
                How Can We Help?
              </h1>
              <p style={{ 
                fontSize: '1.2rem',
                opacity: 0.9,
                maxWidth: '600px',
                margin: '0 auto'
              }}>
                We're here to support you. Reach out and we'll get back to you as soon as possible.
              </p>
            </div>

            {/* Support Cards */}
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '1.5rem',
              marginBottom: '2rem'
            }}>
              {/* Email Support Card */}
              <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '2rem',
                boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 15px 50px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.15)';
              }}>
                <div style={{ 
                  fontSize: '2.5rem',
                  color: '#667eea',
                  marginBottom: '1rem'
                }}>
                  <FaEnvelope />
                </div>
                <h3 style={{ 
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#2d3748'
                }}>
                  Email Support
                </h3>
                <p style={{ 
                  color: '#718096',
                  marginBottom: '1rem',
                  lineHeight: '1.6'
                }}>
                  Send us a detailed message about your issue
                </p>
                <a href="mailto:help@p10rating.com" style={{
                  color: '#667eea',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '1rem'
                }}>
                  help@p10rating.com →
                </a>
              </div>

              {/* FAQ Card */}
              <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '2rem',
                boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 15px 50px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.15)';
              }}>
                <div style={{ 
                  fontSize: '2.5rem',
                  color: '#48bb78',
                  marginBottom: '1rem'
                }}>
                  <FaQuestionCircle />
                </div>
                <h3 style={{ 
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#2d3748'
                }}>
                  FAQ
                </h3>
                <p style={{ 
                  color: '#718096',
                  marginBottom: '1rem',
                  lineHeight: '1.6'
                }}>
                  Find quick answers to common questions
                </p>
                <span style={{
                  color: '#48bb78',
                  fontWeight: '600',
                  fontSize: '1rem'
                }}>
                  Coming Soon →
                </span>
              </div>

              {/* Community Card */}
              <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '2rem',
                boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 15px 50px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.15)';
              }}>
                <div style={{ 
                  fontSize: '2.5rem',
                  color: '#ed8936',
                  marginBottom: '1rem'
                }}>
                  <FaComments />
                </div>
                <h3 style={{ 
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#2d3748'
                }}>
                  Community
                </h3>
                <p style={{ 
                  color: '#718096',
                  marginBottom: '1rem',
                  lineHeight: '1.6'
                }}>
                  Connect with other users
                </p>
                <span style={{
                  color: '#ed8936',
                  fontWeight: '600',
                  fontSize: '1rem'
                }}>
                  Coming Soon →
                </span>
              </div>
            </div>

            {/* Contact Form Section */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '2.5rem',
              boxShadow: '0 10px 40px rgba(0,0,0,0.15)'
            }}>
              <h2 style={{ 
                fontSize: '1.8rem',
                fontWeight: '600',
                marginBottom: '1.5rem',
                color: '#2d3748',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <FaBook style={{ color: '#667eea' }} />
                Need Help?
              </h2>
              <p style={{ 
                color: '#718096',
                marginBottom: '1.5rem',
                lineHeight: '1.8',
                fontSize: '1.05rem'
              }}>
                When contacting support, please include:
              </p>
              <ul style={{ 
                color: '#4a5568',
                lineHeight: '2',
                paddingLeft: '1.5rem',
                marginBottom: '1.5rem'
              }}>
                <li>A detailed description of your issue</li>
                <li>Steps to reproduce the problem</li>
                <li>Device and browser information</li>
                <li>Screenshots if applicable</li>
                <li>Your account email (if relevant)</li>
              </ul>
              <div style={{
                background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)',
                borderRadius: '12px',
                padding: '1.5rem',
                marginTop: '2rem'
              }}>
                <p style={{ 
                  color: 'white',
                  fontSize: '1rem',
                  margin: 0,
                  lineHeight: '1.6'
                }}>
                  📧 <strong>Response Time:</strong> We typically respond within 24-48 hours during business days.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Navbar */}
        <Navbar fixed="bottom" style={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 -2px 20px rgba(0,0,0,0.1)',
          padding: '1rem'
        }}>
          <Nav style={{ 
            width: '100%', 
            display: 'flex', 
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '0.5rem'
          }}>
            <span style={{ margin: '0 0.5rem', color: '#4a5568', fontWeight: '500' }}>
              p10rating © 2026
            </span>
            <Link to='/privacypolicy' style={{ margin: '0 0.5rem', color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>
              Privacy
            </Link>
            <Link to='/disclaimer' style={{ margin: '0 0.5rem', color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>
              Disclaimer
            </Link>
            <Link to='/terms' style={{ margin: '0 0.5rem', color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>
              Terms
            </Link>
            <Link to='/' style={{ margin: '0 0.5rem', color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>
              Sign In
            </Link>
          </Nav>
        </Navbar>
      </div>
    );
  }
}

export default SupportPage;